<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="currency_box"
         style="min-width: 1200px;background: #fff;">
      <el-result icon="success"
                 style="width:100%"
                 :title="data.showIndex==16?'恭喜您购买成功':'恭喜您申请成功'"
                 :subTitle="data.showIndex==16?'下载App畅享精彩课程':'我们将在1-3个工作日与您联系'">
        <template slot="extra">
          <img style="width:220px;height:220px"
               :src="url"
               alt="">
          <div v-if="data.showIndex!=16">扫码了解进度</div>
          <!-- 添加企业微信 -->
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import { resourceList } from '@/api/api.js'
export default {
  components: { curriculumItem },
  data () {
    return {
      url: '',
      data: {
        showIndex: '',  //16为app下载
        pageNumber: 1,
        pageSize: 100,
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.$route.query.type) {
        this.data.showIndex = this.$route.query.type
        this.getresourceList()
      }
    },
    async getresourceList () {  //获取资源
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.url = res.data[0].resourceUrl
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  background-color: #fff;
  .box {
    padding: 40px 0;
    box-sizing: border-box;
  }
}
</style>
